import { Utils } from '../../utils/Utils';

export class PasswordGenerator {
    static generatedTemporaryPassword() {
        return Utils.randomTemporaryPassword(6);
    }
}
